import { render, staticRenderFns } from "./FirstInfoDashboard.vue?vue&type=template&id=9f4d542c&"
import script from "./FirstInfoDashboard.vue?vue&type=script&lang=js&"
export * from "./FirstInfoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports